import { render, staticRenderFns } from "./ImagesUpload.vue?vue&type=template&id=b4033120&scoped=true"
import script from "./ImagesUpload.vue?vue&type=script&lang=js"
export * from "./ImagesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4033120",
  null
  
)

export default component.exports